import { ConfirmationModal } from '@/lib/Modals';
import { ModalDescription, ModalTitle } from '@/lib/Modals/common';
import { IModalContentProps } from '@/models/modals';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSmsSenderDelete } from '../hooks/useSmsSenderDelete';
import { SmsSender } from './types';

export type DeleteSmsSenderModalProps = {
  sender: SmsSender;
  deleteFlowId?: string;
  connectorInstanceId?: string;
  onDeleted: () => void;
} & IModalContentProps;

export const DeleteSmsSenderModal: FC<DeleteSmsSenderModalProps> = ({
  sender,
  deleteFlowId,
  connectorInstanceId,
  onDeleted,
  closeModal,
}) => {
  const { t } = useTranslation('campaign');
  const { deleteSender, isDeleting } = useSmsSenderDelete({ deleteFlowId, connectorInstanceId });

  const handleConfirm = async () => {
    const deleted = await deleteSender(sender.id);
    if (deleted) {
      closeModal();
      onDeleted();
    }
  };

  return (
    <ConfirmationModal
      onClose={closeModal}
      onConfirm={handleConfirm}
      isLoading={isDeleting}
      cancelText='COMMON.cancel'
      confirmText='campaign.smsWorkspace.senders.deleteConfirm'
    >
      <ModalTitle>{t('smsWorkspace.senders.deleteTitle')}</ModalTitle>
      <ModalDescription>{t('smsWorkspace.senders.deleteDescription', { alias: sender.alias })}</ModalDescription>
    </ConfirmationModal>
  );
};
